import topics from "@/data/publicationTopics.json";

const selectCls =
  "h-11 px-4 pr-9 rounded-full border border-[#D3CEC4] bg-[#F8F6F0] text-[13px] text-[#1A2522] focus:outline-none focus:border-[#374F49] transition-colors";

export const PublicationFilters = ({ t, lang, years, usedTopics, year, topic, setYear, setTopic }) => (
  <div className="flex flex-wrap items-end gap-4" data-testid="publication-filters">
    <label className="flex flex-col gap-2 text-[10px] tracking-[0.24em] uppercase font-semibold text-[#374F49]">
      {t.year}
      <select value={year} onChange={(e) => setYear(e.target.value)} className={selectCls} data-testid="filter-year">
        <option value="">{t.all}</option>
        {years.map((y) => (
          <option key={y} value={y}>{y}</option>
        ))}
      </select>
    </label>
    <label className="flex flex-col gap-2 text-[10px] tracking-[0.24em] uppercase font-semibold text-[#374F49]">
      {t.topic}
      <select value={topic} onChange={(e) => setTopic(e.target.value)} className={selectCls} data-testid="filter-topic">
        <option value="">{t.all}</option>
        {topics.filter((tp) => usedTopics.has(tp.id)).map((tp) => (
          <option key={tp.id} value={tp.id}>{tp[lang]}</option>
        ))}
      </select>
    </label>
    {(year || topic) && (
      <button
        type="button"
        onClick={() => { setYear(""); setTopic(""); }}
        data-testid="filter-reset"
        className="h-11 px-5 rounded-full text-[12px] tracking-[0.18em] uppercase font-semibold text-[#374F49] hover:text-[#1A2522] transition-colors"
      >
        {t.reset}
      </button>
    )}
  </div>
);
